export default class ListaClausulaService {
    $q;
    CoreListaRelatorioDefeitoTipo;
    CoreListaRelatorioDefeito;
    CoreDepartamento;
    constructor($q, CoreListaRelatorioDefeitoTipo, CoreListaRelatorioDefeito, CoreDepartamento) {
        this.$q = $q;
        this.CoreListaRelatorioDefeitoTipo = CoreListaRelatorioDefeitoTipo;
        this.CoreListaRelatorioDefeito = CoreListaRelatorioDefeito;
        this.CoreDepartamento = CoreDepartamento;
    }
    findAll(query) {
        return this.CoreListaRelatorioDefeitoTipo.table(query).$promise;
    }
    departamentos() {
        // FIXME: CoreDepartamento tem que ser ligado ao utilizador (fazer vista? Falar com o FM)
        return this.CoreDepartamento.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise;
    }
    findOne(id) {
        return this.CoreListaRelatorioDefeitoTipo.findOne({
            filter: {
                where: {
                    id
                },
                include: ['Defeitos', 'Departamento']
            }
        }).$promise;
    }
    options() {
        return this.CoreListaRelatorioDefeitoTipo.options().$promise;
    }
    patch(id, data) {
        return this.CoreListaRelatorioDefeitoTipo.patch({ id }, data).$promise;
    }
    count(id) {
        return this.CoreListaRelatorioDefeito.count({
            where: {
                coreListaRelatorioDefeitoTipoId: id
            }
        }).$promise;
    }
    create(data) {
        return this.CoreListaRelatorioDefeitoTipo.create(data).$promise;
    }
}
ListaClausulaService.$inject = ['$q', 'CoreListaRelatorioDefeitoTipo', 'CoreListaRelatorioDefeito', 'CoreDepartamento'];
